import React from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'

Font.register({
    family: 'Inter',
    fonts: [
        { src: `${process.env.PUBLIC_URL}/font/Inter-Regular.ttf` }
    ]
})

const styles = StyleSheet.create({
    scaleBarMarkers: {
        width: 1,
        height: 5,
    },
    scaleBarMarkersLast: {
        width: 1,
        height: 5,
    },
});

const initialValue = -10;
const endValue = 100;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 10) {
    finalArray.push({ label: n });
}

const ScaleBarGraph = () => {
    return (
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {finalArray.map((item, index) => {
                return (
                    <View key={index} style={{ width: '10%' }}>
                        <View style={styles.scaleBarMarkers}></View>
                        <View>
                            <Text 
                                style={{
                                    fontFamily: 'Inter',
                                    fontSize: 8,
                                    zIndex: 50,
                                    backgroundColor: '#fff',
                                    marginLeft: index === 0 ? -7 : (index === 1 ? -3 : (index === 8 || index === 9 || index === 10 ? -2 : -5)),
                                }}
                            >{item.label}</Text>
                        </View>
                    </View>
                );
            })}
            <View>
                <View style={styles.scaleBarMarkersLast}></View>
                <View>
                    <Text style={{ fontSize: 8, marginLeft: -6 }}>110</Text>
                </View>
            </View>
        </View>
    )
}

export default ScaleBarGraph